import { useEffect, useState } from "react";
import { Card, Switch, Alert, Spin, Typography, Space, Tag } from "antd";
import { HistoryOutlined } from "@ant-design/icons";
import { toast } from "react-toastify";
import SideBar from "../../../components/SideBar";
import NavBar from "../../../components/NavBar";
import Footer from "../../../components/Footer";
import axiosInstance from "../../../variables/api/axiosInstance";
import { LOGGED_USER } from "../../../variables/constants";

const { Title, Text } = Typography;

// Paramètre GLOBAL (Pool) : autoriser la proposition, dans l'écran de cession, des émissions /
// décaissements des MOIS ANTÉRIEURS jamais cédés. DÉFAUT = false → seul le mois de cession est
// proposé. Modification réservée au Pool (habilitation HOP120) ; le backend l'impose aussi.
const CessionAnterieurs = () => {
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [actif, setActif] = useState(false);

  const hasHOP120 = (LOGGED_USER?.profil?.habilitations || []).some(
    (h) => h?.codeHabilitation === "HOP120"
  );
  const isPool = LOGGED_USER?.profil?.organisme?.typeOrganisme === "POOL";
  const peutModifier = isPool && hasHOP120;

  const fetchParam = () => {
    setLoading(true);
    axiosInstance
      .get("/api/parametre/cession-anterieurs")
      .then((res) => setActif(res.data === true))
      .catch((err) => {
        console.error(err);
        setActif(false);
      })
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    fetchParam();
  }, []);

  const handleToggle = (checked) => {
    setSaving(true);
    axiosInstance
      .put(`/api/parametre/cession-anterieurs/${checked}`)
      .then(() => {
        setActif(checked);
        toast.success(
          checked
            ? "Cession des mois antérieurs ACTIVÉE."
            : "Cession des mois antérieurs DÉSACTIVÉE (seul le mois de cession est proposé)."
        );
      })
      .catch((err) => {
        const msg =
          err?.response?.data?.message ||
          "Erreur lors de l'enregistrement du paramètre";
        toast.error(msg);
        console.error(err);
        fetchParam(); // resynchroniser l'affichage sur la valeur réelle
      })
      .finally(() => setSaving(false));
  };

  return (
    <div className="layout-wrapper layout-content-navbar">
      <div className="layout-container">
        <SideBar currentMenu={"AUTRES_PARAMETRES"} />
        <div className="layout-page">
          <NavBar />
          <div className="content-wrapper" style={{ background: "#f6f7fb" }}>
            <div className="container-xxl flex-grow-1 container-p-y">
              <Title level={4} style={{ color: "#242166", marginBottom: 4 }}>
                <HistoryOutlined /> Cession des mois antérieurs
              </Title>
              <Text type="secondary">
                Paramètre global. Autorise (ou non) la proposition, dans l'écran de cession, des
                émissions et décaissements des <strong>mois antérieurs</strong> jamais cédés.
              </Text>

              <Card size="small" style={{ marginTop: 16, maxWidth: 720 }}>
                <Spin spinning={loading}>
                  <Alert
                    type="info"
                    showIcon
                    style={{ marginBottom: 16 }}
                    message="Comportement par défaut : désactivé"
                    description="Désactivé, l'écran de cession ne propose QUE les éléments du mois de cession. Activé, les orphelins des mois passés remontent (décochés par défaut, cochables sans habilitation). Réservé au Pool."
                  />

                  <Space align="center" size="middle">
                    <Switch
                      checked={actif}
                      loading={saving}
                      disabled={!peutModifier}
                      onChange={handleToggle}
                    />
                    <Tag color={actif ? "green" : "default"}>
                      {actif ? "Antérieurs AUTORISÉS" : "Mois de cession uniquement"}
                    </Tag>
                  </Space>

                  {!peutModifier && (
                    <p className="text-muted" style={{ marginTop: 12, marginBottom: 0 }}>
                      Modification réservée au Pool (habilitation <strong>HOP120</strong>).
                    </p>
                  )}
                </Spin>
              </Card>
            </div>
          </div>
          <Footer />
        </div>
      </div>
    </div>
  );
};

export default CessionAnterieurs;
